


// // src/components/routes/AuthRoute.tsx
// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { getToken } from '../utils/localStorage';
// import { useAppSelector } from '../app/hooks';

// interface AuthRouteProps {
//   children: React.ReactElement;
// }

// const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
//   const location = useLocation();
//   const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
//   const isRegistered = useAppSelector((state) => state.auth.isRegistered);
  
//   const userBaseData = localStorage.getItem('baseDetails') ? 
//     JSON.parse(localStorage.getItem('baseDetails') || '{}') : null;
//   const baseId = userBaseData?.data?.base?.id;

//   // List of public authentication routes
//   const authPaths = ['/', '/signup', '/forgotpassword', '/reset-password'];

//   // Check if current path is an auth path
//   const isAuthPath = authPaths.includes(location.pathname) || 
//                     location.pathname.startsWith('/reset-password/');

//   // Special handling for OTP page
//   if (location.pathname === '/otp') {
//     // Only allow access to OTP page if user is registered but not authenticated
//     // if (isRegistered) {
//     //   return <Navigate to="/signup" replace />;
//     // }
//     return children;
//   }

//   // Redirect to dashboarde if authenticated and trying to access auth pages
//   if (isAuthenticated && isAuthPath && baseId) {
//     return <Navigate to={`/${baseId}/dashboard`} replace />;
//   }

//   return children;
// };

// export default AuthRoute;








// src/components/routes/AuthRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from '../utils/localStorage';
import { useAppSelector } from '../app/hooks';

interface AuthRouteProps {
  children: React.ReactElement;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isRegistered = useAppSelector((state) => state.auth.isRegistered);
  // Check for token in localStorage
  const token = getToken() || localStorage.getItem('authorization');
  
  const userBaseData = localStorage.getItem('baseDetails') ? 
    JSON.parse(localStorage.getItem('baseDetails') || '{}') : null;
  const baseId = userBaseData?.data?.base?.id;

  // List of public authentication routes
  const authPaths = ['/', '/login', '/signup', '/forgotpassword', '/reset-password'];

  // Check if current path is an auth path
  const isAuthPath = authPaths.includes(location.pathname) || 
                    location.pathname.startsWith('/reset-password/');

  // Special handling for OTP page
  if (location.pathname === '/otp') {
    return children;
  }

  // Check if user is authenticated (either from Redux state OR localStorage token)
  const userIsAuthenticated = isAuthenticated || !!token;

  // Redirect to dashboard if authenticated and trying to access auth pages
  if (userIsAuthenticated && isAuthPath && baseId) {
    return <Navigate to={`/${baseId}/dashboard`} replace />;
  }

  return children;
};

export default AuthRoute;